import { render, staticRenderFns } from "./CreateCourse.vue?vue&type=template&id=8a619f4e&scoped=true&"
import script from "./CreateCourse.vue?vue&type=script&lang=js&"
export * from "./CreateCourse.vue?vue&type=script&lang=js&"
import style0 from "./CreateCourse.vue?vue&type=style&index=0&id=8a619f4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a619f4e",
  null
  
)

export default component.exports